import { FULFILLMENT_STATUS_LABELS } from '../constants/fulfillmentStatus';

export function collectionStatus(order) {
  const collection = order.collection;
  const shipment = collection?.shipment;
  if (collection?.returnPending) return 'Отменён · товары нужно вернуть продавцам';
  if (order.status === 'CANCELLED' || shipment?.status === 'CANCELLED') return 'Отменён';
  if (collection?.hasCancelledItems) return 'Есть отменённые позиции';
  if (shipment?.syncFailed) return 'Ошибка проверки статуса Яндекса';
  if (shipment?.status === 'RETURNING') return 'Яндекс возвращает посылку';
  if (shipment?.status === 'RETURNED') return 'Посылка возвращена';
  if (shipment?.status === 'DELIVERY_FAILED') return 'Проблема с доставкой';
  if (shipment?.status === 'DELIVERED') return 'Доставлено';
  if (shipment?.handedOverAt) return 'Яндекс подтвердил приём';
  if (shipment?.barcode) return 'Готово к сдаче · ожидаем приём Яндекса';
  if (shipment?.labelAvailable) return 'Заявка создана · ожидаем транспортный штрихкод';
  if (shipment?.creationState === 'FAILED') return 'Ошибка создания заявки Яндекса';
  if (shipment?.creationState === 'IN_PROGRESS') return 'Заявка Яндекса проверяется';
  if (shipment?.packed) return 'Упаковано · ожидает создания заявки';
  if (collection?.incomplete) return 'Есть неполученные позиции';
  return FULFILLMENT_STATUS_LABELS[order.fulfillmentStatus] || order.fulfillmentStatus;
}
